<template>
  <div class="_wrapper" ref="_wrapper">
    <div class="out" ref="out">
      <div ref="inner" class="inner">
        <slot></slot>
      </div>
    </div>
    <div
      v-show="showTab"
      style="color:#fff;"
      @click="left"
      class="left"
      :class="canLeft?'active':''"
    >
      <div class="text">
        <span class="oi oi-chevron-left"></span>
      </div>
    </div>
    <div
      v-show="showTab"
      style="color:#fff;"
      @click="right"
      class="right"
      :class="canRight?'active':''"
    >
      <div class="text">
        <span class="oi oi-chevron-right"></span>
      </div>
    </div>
  </div>
</template>
<script>
export default {
  props: {
    boxWidth: {
      type: Number,
      default: 1
    },
    moveWidth: {
      type: Number
    }
  },
  data() {
    return {
      showTab: false,
      page: 1,
      currentPage: 1,
      canLeft: false,
      canRight: false
    };
  },
  mounted() {
    this.$refs._wrapper.style.width = this.boxWidth + "px";
    this.$refs.out.style.width = this.boxWidth + "px";
    let innerWidth = 0;
    let length = this.$refs.inner.children.length;
    for (let i = 0; i < length; i++) {
      innerWidth += this.$refs.inner.children[i].offsetWidth;
    }
    this.$refs.inner.style.width = innerWidth + "px";
    this.page = Math.ceil(
      innerWidth / (this.moveWidth ? this.moveWidth : this.boxWidth)
    );
    if (this.page > 1) {
      this.canRight = true;
    }
    if (this.boxWidth >= innerWidth) {
      this.showTab = false;
    } else {
      this.showTab = true;
    }
  },
  methods: {
    left() {
      if (this.currentPage === 1) return;
      this.currentPage--;
      this.$refs.inner.style.transform =
        "translateX(-" +
        (this.currentPage - 1) *
          (this.moveWidth ? this.moveWidth : this.boxWidth) +
        "px)";
    },
    right() {
      if (this.currentPage === this.page) return;
      this.currentPage++;
      this.$refs.inner.style.transform =
        "translateX(-" +
        (this.currentPage - 1) *
          (this.moveWidth ? this.moveWidth : this.boxWidth) +
        "px)";
    }
  },
  watch: {
    currentPage() {
      if (this.currentPage === 1) {
        this.canLeft = false;
        this.canRight = true;
      } else if (this.currentPage === this.page) {
        this.canLeft = true;
        this.canRight = false;
      } else {
        this.canLeft = true;
        this.canRight = true;
      }
    }
  }
};
</script>
<style lang="less" scoped>
._wrapper {
  position: relative;
  .out {
    overflow: hidden;
    .inner {
      overflow: hidden;
      box-shadow: 0 0 5px 0 rgba(20, 20, 31, 0.15);
      transition: all 0.3s ease;
    }
  }
  .left,
  .right {
    -webkit-user-select: none;
    -moz-user-select: none;
    -ms-user-select: none;
    user-select: none;
    width: 20px;
    height: 20px;
    border-radius: 50%;
    background-color: #eee;
    position: absolute;
    top: -23px;
    cursor: pointer;
  }
  .left {
    right: 26px;
    .text {
      margin-left: 4px;
    }
  }
  .right {
    right: 2px;
    .text {
      margin-left: 7px;
    }
  }
  .active {
    background-color: #c7c4c4;
  }
}
</style>